export default "__VITE_ASSET__Bc3409xu__"